import React, { Suspense } from 'react';
import { hot } from 'react-hot-loader';
import { makeStyles } from '@material-ui/core/styles';
import { VisualizationContainer } from './ContextProviders/VisualizationProvider';
import ContextMenu from './ContextMenu';
import ConfigurationMenu from './Components/ConfigurationMenu/ConfigurationMenu';
import VisualizationToolbar from './Components/VisuailzationToolbar/VisualizationToolbar';
import ConfigurationToolbar from './Components/ConfigurationToolbar/ConfigurationToolbar';
import { GlobalLoader } from './GlobalLoader';
import RequestOffer from './Components/RequestOffer/RequestOffer';
import HowToConfigureHint from './Components/HowToConfigureHint/HowToConfigureHint';
import MyConfiguration from './Components/MyConfiguration/MyConfiguration';
import { Footer } from './Components/Footer';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  visualizationContainer: {
    flex: 1,
    overflow: 'hidden',
    '& > *': {
      display: 'flex',
    },
  },
  appContainer: {
    flex: 1,
  },
  bottomContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      [theme.media.portrait]: {
        flexDirection: 'column',
      },
    },
  },
  ctaContainer: {
    display: 'flex',
    gap: 16,
    alignSelf: 'center',
    [theme.breakpoints.up('sm')]: {
      padding: '0 30px',
    },
  },
}));

const Main = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <VisualizationContainer className={classes.visualizationContainer} />
      <Suspense fallback={''}>
        <ConfigurationToolbar />
        <VisualizationToolbar />
        <ContextMenu />
        <div className={classes.bottomContainer}>
          <ConfigurationMenu />
          <div className={classes.ctaContainer}>
            <MyConfiguration />
            <RequestOffer />
          </div>
        </div>
        <HowToConfigureHint />
      </Suspense>
      <GlobalLoader />
      <Footer />
    </div>
  );
};

export default hot(module)(Main);
